import { useAppDispatch } from "store/store";
import { Mode } from "../types";
import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";

export const useColorList = (textBox: TextBox, mode: Mode) => {
    const dispatch = useAppDispatch();

    function onColorChoose(color: string) {
        switch (mode) {
            case "text":
                dispatch(
                    setSettings({
                        id: textBox.id,
                        fontColor: color,
                    }),
                );
                break;
            case "outline":
                dispatch(
                    setSettings({
                        id: textBox.id,
                        outline: {
                            size: textBox.outline?.size || 1,
                            color: color,
                            isActive: true,
                        },
                    }),
                );
                break;
            case "shadow":
                dispatch(
                    setSettings({
                        id: textBox.id,
                        shadow: {
                            blurRadius: textBox.shadow?.blurRadius || 1,
                            color: color,
                            isActive: true,
                        },
                    }),
                );
        }
    }

    return {
        onColorChoose,
    };
};
